var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.557,
    height: 18.031,
    viewBox: "0 0 18.557 18.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(-6 -9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10549",
    "data-name": "Path 10549",
    d: "M23.629,19a.966.966,0,0,0-.928,1v5H7.856V20a.966.966,0,0,0-.928-1A.966.966,0,0,0,6,20v5.14a2,2,0,0,0,.57,1.345A1.718,1.718,0,0,0,7.856,27H22.7a1.718,1.718,0,0,0,1.286-.515,2,2,0,0,0,.57-1.345V20A.966.966,0,0,0,23.629,19Z",
    transform: "translate(0 0.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10550",
    "data-name": "Path 10550",
    d: "M14.633,16.789h0a1.076,1.076,0,0,0,.229.135h0a.991.991,0,0,0,.413.105,1.008,1.008,0,0,0,.334-.06l.106-.053a1.02,1.02,0,0,0,.158-.09h0l4.4-4.045a.678.678,0,0,0-.04-1.064.988.988,0,0,0-1.244.034L16.155,14.36V5.752a.89.89,0,0,0-1.758,0V14.36l-2.875-2.646a.988.988,0,0,0-1.244-.034.678.678,0,0,0-.04,1.064Z",
    transform: "translate(0.025 4)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.fc77c2c7ad9ea5cacbd424cea92936f2.svg";
export { ForwardRef as ReactComponent };